import React from "react";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";

const Textarea = ({label, star, placeholder, value, onChange, required}) => {
    return(
        <div className={classes.custom_text_area}>
            <label>{label}<span>{star}</span></label>
            <textarea required={required} placeholder={placeholder} value={value} onChange={onChange} />
        </div>
    )
}

Textarea.propTypes = {
    onChange : PropTypes.func,
    required : PropTypes.bool,
    value : PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    star: PropTypes.node,
};

export default Textarea;